var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-color-hue-slider"},[_c('div',{ref:"bar",staticClass:"q-color-hue-slider__bar",on:{"click":_vm.handleBarClick}}),_c('div',{ref:"thumb",staticClass:"q-color-hue-slider__thumb",style:(_vm.thumbStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }